import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ShieldAlert } from "lucide-react";
import { useAuth } from "../lib/AuthContext";

export default function MfaGraceBanner() {
  const { user } = useAuth();
  const { t, i18n } = useTranslation("auth");
  const navigate = useNavigate();

  if (!user || user.mfa_status !== "grace") return null;

  let dateLabel = "";
  if (user.mfa_grace_deadline) {
    try {
      dateLabel = new Date(user.mfa_grace_deadline).toLocaleDateString(
        i18n.language === "fr" ? "fr-CA" : "en-CA",
        { year: "numeric", month: "long", day: "numeric" }
      );
    } catch { /* ignore */ }
  }

  return (
    <div
      className="flex flex-wrap items-center gap-3 px-4 py-3 bg-amber-50 border-b border-amber-200 text-amber-900"
      data-testid="mfa-grace-banner"
      role="alert"
    >
      <ShieldAlert size={18} strokeWidth={1.75} className="shrink-0 text-amber-700" />
      <div className="min-w-0 text-sm">
        <span className="font-medium">{t("two_factor.enforcement.banner_title")}</span>{" "}
        <span className="text-amber-800">
          {t("two_factor.enforcement.banner_body", { date: dateLabel })}
        </span>
      </div>
      <button
        onClick={() => navigate("/enroll-2fa")}
        data-testid="mfa-grace-banner-cta"
        className="ml-auto shrink-0 h-8 px-3 rounded-lg bg-amber-600 hover:bg-amber-700 text-white text-xs font-medium transition-colors"
      >
        {t("two_factor.enforcement.banner_cta")}
      </button>
    </div>
  );
}
